export default __webpack_public_path__ + "static/media/about.2aed7083.png";